import BaseClient from '@/app/model/api/response/baseApiClient'

class ExternalLinkContentCreateApi extends BaseClient {
  public doExternalLinkContentCreate (data: any, contentfile: any) {
    const path: string = '/v1/external-link-contents'
    const formData = new FormData()
    formData.append('external_link_id', data.external_link_id)
    formData.append('content_name', data.content_name)
    formData.append('record_date', data.record_date)
    formData.append('remarks', data.remarks)

    if (data.url !== '') {
      formData.append('content_url', data.url)
    } else {
      formData.append('content_file', contentfile)
    }
    /* 共通処理 */
    return super.donotUseContentType().setBody(formData).doFetch(process.env.VUE_APP_API_URL + path, 'POST')
  }
}

export default new ExternalLinkContentCreateApi()
